import { MinusIcon, PlusIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ChangeEvent, InputHTMLAttributes, ReactNode } from "react";
import React from "react";

export interface QuantityProps extends InputHTMLAttributes<HTMLInputElement> {
  dense?: boolean;
  value: number;
  disabled?: boolean;
  onDecrease?: React.MouseEventHandler<HTMLButtonElement>;
  onIncrease?: React.MouseEventHandler<HTMLButtonElement>;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  DecreaseIcon?: ReactNode;
  IncreaseIcon?: ReactNode;
  classNames?: {
    wrapper?: string;
    increaseButton?: string;
    decreaseButton?: string;
    input?: string;
  };
}

export const Quantity = ({
  value,
  dense = false,
  disabled = false,
  onDecrease,
  onIncrease,
  onBlur,
  onChange,
  DecreaseIcon = <MinusIcon strokeWidth={1} className="mx-2 size-4" />,
  IncreaseIcon = <PlusIcon strokeWidth={1} className="mx-2 size-4" />,
  classNames,
  ...rest
}: QuantityProps) => (
  <div
    className={cn(
      "color-black flex border border-black bg-white",
      dense ? "h-8" : "h-12",
      disabled ? "pointer-events-none opacity-50" : "",
      classNames?.wrapper,
    )}
  >
    <button
      aria-label="decreaseButton"
      type="button"
      className={cn(
        "shrink-0 basis-7 bg-white transition hover:opacity-75",
        classNames?.decreaseButton,
      )}
      onClick={onDecrease}
    >
      {DecreaseIcon}
    </button>

    <input
      {...rest}
      type="number"
      className={cn("w-full text-center text-base", classNames?.input)}
      value={value || ""}
      onChange={onChange}
      onBlur={onBlur}
    />

    <button
      type="button"
      className={cn(
        "shrink-0 basis-7 bg-white transition hover:opacity-75",
        classNames?.increaseButton,
      )}
      aria-label="increaseButton"
      onClick={onIncrease}
    >
      {IncreaseIcon}
    </button>
  </div>
);
